import { Injectable } from '@angular/core';
import MicroModal from 'micromodal';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor() { }

  openModal(idModal: string, disableOverlayClick: boolean = false) {
    MicroModal.init({
      disableScroll: true,
      disableOverlayClick: disableOverlayClick
    });
    MicroModal.show(idModal);
  }
  
  closeModal(idModal: string) {
    MicroModal.close(idModal);
  }
  

}
